import { defineTokens } from "@chakra-ui/react";

export const colorsToken = defineTokens.colors({
  textBlack: {
    100: { value: "#FFFFFF" },
    200: { value: "#F5F5F5" },
    300: { value: "#DCDCDC" },
    400: { value: "#BFBFBF" },
    600: { value: "#747474" },
    700: { value: "#454545" },
    800: { value: "#1A1A1A" },
  },
  primary: {
    50: { value: "#8099B8" },
    100: { value: "#F0F4F9" },
    200: { value: "#DDE5EE" },
    300: { value: "#CBD6E3" },
    400: { value: "#B8C6D8" },
    500: { value: "#A5B7CD" },
    600: { value: "#8099B8" },
    700: { value: "#5A7AA2" },
    800: { value: "#355C8C" },
    900: { value: "#2A4A70" },
    1000: { value: "#203754" },
    1100: { value: "#152538" },
    1200: { value: "#0B121C" },
  },

  green: {
    100: { value: "#F6FFFF" },
    200: { value: "#EEF8F7" },
    300: { value: "#DDF1F0" },
    400: { value: "#CCE9E8" },
    500: { value: "#BBE2E0" },
    600: { value: "#9AD4D1" },
    700: { value: "#78C5C1" },
    800: { value: "#56B7B2" },
    900: { value: "#45928E" },
    1000: { value: "#346E6B" },
    1100: { value: "#224947" },
    1200: { value: "#112524" },
  },

  grey: {
    100: { value: "#C1C0C0" },
    200: { value: "#B2B1B1" },
    300: { value: "#A3A2A2" },
    400: { value: "#959494" },
    500: { value: "#868585" },
    600: { value: "#686767" },
    700: { value: "#4B4A4A" },
    800: { value: "#2D2C2C" },
    900: { value: "#242323" },
    1000: { value: "#1B1A1A" },
    1100: { value: "#121212" },
    1200: { value: "#0E0D0D" },
  },

  yesem: {
    300: { value: "#2677CE" },
    500: { value: "#004FA3" },
    700: { value: "#003C7C" },
    900: { value: "#002A57" },
  },

  orange: {
    500: { value: "#FF6A38" },
  },
  red: {
    50: { value: "#FEF2F2" },
    100: { value: "#FEE2E2" },
    200: { value: "#FECACA" },
    300: { value: "#FCA5A5" },
    400: { value: "#F87171" },
    500: { value: "#EF4444" },
    600: { value: "#DC2626" },
    700: { value: "#991919" },
    800: { value: "#511111" },
    900: { value: "#300C0C" },
  },
  error: {
    500: { value: "#CC0000" },
  },
  errorLight: {
    500: { value: "#FFE0E0" },
  },
  success: {
    500: { value: "#358000" },
  },
  successLight: {
    500: { value: "#EEFFE2" },
  },
  warning: {
    500: { value: "#FEBB30" },
  },
  warningLight: {
    500: { value: "#FFEECC" },
  },
  info: {
    500: { value: "#1B86C3" },
  },
  infoLight: {
    500: { value: "#E2F2FB" },
  },
  link: {
    500: { value: "#004D99" },
  },
  focus: {
    500: { value: "#BD13B8" },
  },
});
